import { usePalmistryContext } from "@/features/webapp"

import FinishPalm from "@/assets/img/palmistry/scan/finish_palm.webp"
import { scanCopy } from "../config/copy"

interface ReportBeingPreparedProps {
  onDone: () => void
}

/** Post-scan waiting screen with the 10-minute unlock countdown. Ported from PalmistryReportIsBeingPrepared. */
export function ReportBeingPrepared({ onDone }: ReportBeingPreparedProps) {
  const { timeLeft } = usePalmistryContext()

  return (
    <div className="fixed inset-0 z-[1000] mx-auto flex min-h-[100dvh] w-full max-w-app flex-col items-center bg-dark-base py-4">
      <div className="relative flex min-h-0 w-full flex-1">
        <img src={FinishPalm} alt="" className="pointer-events-none size-full object-contain" />
      </div>

      <div className="flex w-full flex-col items-center gap-6 px-4">
        <div className="flex w-full flex-col items-center gap-4">
          <div className="flex w-full flex-col items-center gap-2">
            <h2 className="whitespace-pre-line text-center font-display text-2xl font-medium text-purple-light">
              {scanCopy.prepared.title}
            </h2>
            <p className="text-center font-body text-base text-purple-light/70">
              {scanCopy.prepared.subtitle}
            </p>
          </div>

          <div className="flex flex-col items-center rounded-2xl bg-purple-light/10 px-6 pb-2 pt-3">
            <p className="font-body text-[10px] font-medium uppercase text-purple-light/70">
              {scanCopy.prepared.unlocksIn}
            </p>
            <p className="font-display text-[40px] font-bold text-white">{timeLeft ?? "10:00"}</p>
          </div>
        </div>

        <button
          type="button"
          onClick={onDone}
          className="flex h-14 w-full items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
        >
          {scanCopy.prepared.button}
        </button>
      </div>
    </div>
  )
}
